<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useRoute } from "vue-router";
import { useAbility } from "@casl/vue";
import AlignerDeliveryAddEdit from "@/components/models/patient/forms/visitInstructions/AlignerDeliveryAddEdit.vue";
import { useAlignerDeliveryInstructionById } from "@/composables/models/patient/visitInstructions/useAlignerDelivery.ts";

definePage({
  meta: {
    title: "generic.action.editEntity",
    titleParams: { entity: "generic.entity.alignerDeliveryInstructions" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.READ, $permSubjects.PATIENT__ALIGNERDELIVERYINSTRUCTIONS);
    },
  },
});

const route = useRoute();
const routeParams = route.params as { id: string };

const { data: alignerDeliveryInstructions, isLoading } = useAlignerDeliveryInstructionById({
  id: routeParams.id,
});
</script>

<template>
  <v-skeleton-loader :loading="isLoading">
    <aligner-delivery-add-edit
      :aligner-delivery-instructions="alignerDeliveryInstructions"
      readonly
    />
  </v-skeleton-loader>
</template>

<style scoped></style>
